import camelcaseKeys from 'camelcase-keys'
import { ReservationMethod } from '@/entities/activities/ReservationMethod'
import { PageObjectLinkedContent } from '@/entities/webapp-pages/page-objects/LinkedContent.js'
import { PageObjectRelatedPage } from '@/entities/webapp-pages/page-objects/RelatedPage.js'
import { PageObjectLocation } from '@/entities/webapp-pages/page-objects/Location.js'
import { getFileURL } from '@/lib/helpers/FileURLGetter'

export class PageService {
  constructor (params = {}) {
    const { service, reservationMethods, linkedContent, relatedPages, location: webappLocation } = camelcaseKeys(params ? params : {}, { deep: true })
    const { id, title, shortDescription, description, dressCode, imageFileIds, facilityId, activityId } = camelcaseKeys(service || {}, { deep: true })
    this.id = id || null
    this.title = title || []
    this.shortDescription = shortDescription || []
    this.description = description || []
    this.dressCode = dressCode || []
    this.imageFileIds = imageFileIds || []
    this.imageFiles = Array.isArray(this.imageFileIds) ? this.imageFileIds.map((imageFileId) => getFileURL(imageFileId)) : []
    this.location = webappLocation ? new PageObjectLocation(webappLocation) : null
    this.facilityId = facilityId || null
    this.activityId = activityId || null

    this.reservationMethods = reservationMethods ? reservationMethods.map((item) => {
      return new ReservationMethod(item)
    }) : []
    this.linkedContent = Array.isArray(linkedContent) ? linkedContent.map((content) => new PageObjectLinkedContent(content)) : null
    this.relatedPages = Array.isArray(relatedPages) ? relatedPages.map((relatedPage) => new PageObjectRelatedPage(relatedPage)) : null
  }
}
